import { EventHandler } from "../../util/event/EventHandler";
import { Logger } from "../../util/log/Logger";
import { Timer } from "../../util/time/Timer";
import { RealityCheckDetailsRequest } from "../common/controller/net/request/RealityCheckDetailsRequest";
import { WinLossRequest } from "../common/controller/net/request/WinLossRequest";
import { AbstractHandler } from "../core/handler/AbstractHandler";
/**
 * RealityCheckTimeoutHandler.ts
 */
export class RealityCheckTimeoutHandler extends AbstractHandler {
    create() {
        super.create();
        this.createTimer();
        this.run();
    }
    createTimer() {
        this.timer = new Timer(10000);
        this.timer.onUpdate(this.handleTimerUpdate, this);
    }
    onRealityCheckTimeout(winLossEnabled, action, scope) {
        this.winLossEnabled = winLossEnabled;
        this.timeoutHandler = new EventHandler(action, scope);
    }
    onRealityCheckRefresh(action, scope) {
        this.detailsHandler = new EventHandler(action, scope);
        this.sendDetailsRequest();
    }
    refresh() {
        this.sendDetailsRequest();
    }
    restartTimer(timeToExpiry) {
        this.timer.reset(timeToExpiry);
        this.timer.start();
    }
    handleTimerUpdate() {
        this.handleExpiry();
    }
    sendWinLossRequest() {
        let request = new WinLossRequest();
        request.onSuccess(this.handleWinLossSuccess, this);
        request.onFailure(this.handleWinLossFailed, this);
        request.send();
    }
    sendDetailsRequest() {
        let request = new RealityCheckDetailsRequest();
        request.onSuccess(this.handleCheckDetailsSuccess, this);
        request.onFailure(this.handleCheckDetailsFailed, this);
        request.send();
    }
    handleCheckDetailsSuccess(data) {
        if (this.detailsHandler) {
            this.details = data;
            this.detailsHandler.call(this.details);
            if (this.details.isEnabled()) {
                if (this.details.hasExpired()) {
                    this.handleExpiry();
                }
                else {
                    this.restartTimer(this.details.getTimeToExpiry());
                }
            }
        }
    }
    handleCheckDetailsFailed() {
        Logger.debug("Handle Reality Check Details Failed");
    }
    handleWinLossSuccess(data) {
        if (this.timeoutHandler) {
            this.winLoss = data;
            if (this.details.isEnabled()) {
                this.timeoutHandler.call(this.winLoss);
                this.restartTimer(this.details.getRealityCheckInterval());
            }
        }
    }
    handleWinLossFailed() {
        Logger.debug("Handle Win Loss Failed");
    }
    handleExpiry() {
        if (this.timeoutHandler) {
            if (this.winLossEnabled) {
                this.sendWinLossRequest();
            }
            else {
                this.timeoutHandler.call();
                this.restartTimer(this.details.getRealityCheckInterval());
            }
        }
    }
}
//# sourceMappingURL=RealityCheckTimeoutHandler.js.map